// TODO use the API to get the list of markets
const BC_MARKETS = [
  'vancouver',
] as const;

const ALL_CANADIAN_MARKETS = [
  ...BC_MARKETS,
  'toronto',
  'ottawa',
  'kwc',
  'hamilton',
  'calgary',
] as const;

const CALIFORNIA_MARKETS = [
  'bay area',
  'san diego',
  'los angeles',
  'sacramento',
] as const;

const ALL_US_MARKETS = [
  ...CALIFORNIA_MARKETS,
  'chicago',
  'denver',
  'austin',
  'dallas',
  'houston',
  'miami',
  'phoenix',
  'new york city',
  'las vegas',
  'seattle',
  'detroit',
] as const;

// Experiment Documentation: https://www.notion.so/opencare/Creating-an-Experiment-188133bf427f418c9de367ef3586db88?pvs=4

export const VARIANTS = Object.freeze({
  CONTROL: 'CONTROL',
  VARIANT: 'VARIANT',
});

export type Market = typeof ALL_CANADIAN_MARKETS[number] | typeof ALL_US_MARKETS[number];

export interface Experiment {
  name: ExperimentName;
  markets?: readonly Market[];
  excludeMarkets?: readonly Market[];
}

export enum ExperimentName {
  OFFER_ELIGIBILITY_ACKNOWLEDGEMENT = 'checkout-offer-eligibility-acknowledgement',
  CHECKOUT_OPTIONAL_MEMBER_ID = 'checkout-optional-member-id',
  OFFER_BANNER_AUTO_APPLIED_MESSAGING = 'offer-banner-auto-applied-messaging',
  FUNNEL_SKIP_INSURANCE = 'funnel-skip-insurance',
  CHECKOUT_SECURITY_MESSAGING = 'checkout-security-messaging',
}

export enum ExperimentVariantType {
  CONTROL = 'CONTROL',
  VARIANT = 'VARIANT',
}

export interface AssignedExperiment {
  name: ExperimentName;
  variant: {
    type: ExperimentVariantType;
    variantNumber: `${number}`; // Stringified number
  };
}

/**
 * name: Short name of the experiment. Must match the name in ExperimentConfigs in the API
 * markets: List of markets where the experiment will run
 * excludeMarkets: List of markets where the experiment will not run
 */
export const EXPERIMENTS: Record<ExperimentName, Experiment> = {
  [ExperimentName.OFFER_ELIGIBILITY_ACKNOWLEDGEMENT]: {
    name: ExperimentName.OFFER_ELIGIBILITY_ACKNOWLEDGEMENT,
    markets: ALL_US_MARKETS,
    excludeMarkets: [
      ...CALIFORNIA_MARKETS,
    ],
  },
  [ExperimentName.CHECKOUT_OPTIONAL_MEMBER_ID]: {
    name: ExperimentName.CHECKOUT_OPTIONAL_MEMBER_ID,
  },
  [ExperimentName.OFFER_BANNER_AUTO_APPLIED_MESSAGING]: {
    name: ExperimentName.OFFER_BANNER_AUTO_APPLIED_MESSAGING,
  },
  [ExperimentName.FUNNEL_SKIP_INSURANCE]: {
    name: ExperimentName.FUNNEL_SKIP_INSURANCE,
  },
  [ExperimentName.CHECKOUT_SECURITY_MESSAGING]: {
    name: ExperimentName.CHECKOUT_SECURITY_MESSAGING,
    markets: [
      ...CALIFORNIA_MARKETS,
      ...BC_MARKETS,
    ],
  },
};
